import Attrs from '../../models/Attrs'
import type { FlowPage, OptionSelector } from '../../models/types'

export default function renderPageHeadingLabel(
  component: OptionSelector,
  attrs: Attrs,
  page: FlowPage
): string {
  const inPageClasses = [
    `in-page-key-${page.key}`,
    ...(page.tags || []).map((tag) => `in-page-tag-${tag}`),
  ]
  attrs.addDOMClass(['heading-label', ...inPageClasses])
  attrs.addController('template')
  return `<div ${attrs}>${page.headingLabel || ''}</div>`
}
